import store from '../store';

export function hasBusinessPermission(capability, chainId, branchId) {
    const { permissions } = store.getState().auth;

    if (permissions.business) {
        const { chains, branches, isOperation } = permissions.business;

        if (capability) {
            const [app, cap] = capability.split(':');
            if (app === 'operation' && !isOperation) return false;
            if (app && !permissions.business[app]) return false;

            const { capabilities } = app ? permissions.business[app] : {};
            if (capabilities && cap && !capabilities.includes(cap)) return false;
        }

        if (chainId && (!chains || chains.ids && !chains.ids.includes(chainId))) return false;
        if (branchId && (!branches || branches.ids && !branches.ids.includes(branchId))) return false;        
    } else if (permissions.restaurant) {
        if (capability === 'operation') {
            if (!permissions.admin) return false;
            if (permissions.admin.capabilities && !permissions.admin.capabilities.includes(capability)) return false;

            return true;
        }

        const { ids, ownersIds, capabilities } = permissions.restaurant;

        if (chainId && ownersIds && !ownersIds.includes(chainId)) return false;
        if (branchId && ids && !ids.includes(branchId)) return false;
        if (capabilities && capability && !capabilities.includes(capability)) return false;
    } else {
        return false;
    }

    return true;
}

export function hasBudgetsPermission(capability, companyId) {
    const { permissions } = store.getState().auth;

    if (permissions.budgets) {
        const { capabilities, companiesIds, isOperation } = permissions.budgets;

        if (capability === 'operation' && !isOperation) return false;
        if (capabilities && capability && !capabilities.includes(capability)) return false;
        if (companyId && companiesIds && !companiesIds.includes(companyId)) return false;
    } else if (permissions.company) {
        if (capability === 'operation') {
            if (!permissions.admin) return false;
            if (permissions.admin.capabilities && !permissions.admin.capabilities.includes(capability)) return false;

            return true;
        }
        
        const { ids, capabilities } = permissions.company;
        if (ids && companyId && !ids.includes(companyId)) return false;
        if (capabilities && capability && !capabilities.includes(capability)) return false;
    } else {
        return false;
    }

    return true;
}

export function hasLoyaltyPermission(capability, loyaltyId) {
    const { permissions } = store.getState().auth;

    if (permissions.loyalty) {
        const { capabilities, ids: loyaltProgramsIds } = permissions.loyalty;

        if (capability === 'operation') {
            if (!permissions.admin) return false;
            if (permissions.admin.capabilities && !permissions.admin.capabilities.includes(capability)) return false;

            return true;
        }
        if (capabilities && capability && !capabilities.includes(capability)) return false;
        if (loyaltyId && loyaltProgramsIds && !loyaltProgramsIds.includes(loyaltyId)) return false;
    } else {
        return false;
    }

    return true;
}

export function hasSuperPermission(capability) {
    const { permissions } = store.getState().auth;

    if (permissions.super || permissions.admin) {
        const { capabilities } = permissions.super || permissions.admin;
        if (capabilities && capability && !capabilities.includes(capability)) return false;
    } else {
        return false;
    }

    return true;
}

export function hasPermissionOn(type, capability, id) {
    const { permissions } = store.getState().auth;
    let eligable = false;

    if (type === 'admin') {
        eligable = permissions.admin && !permissions.admin.isSupervisor;
    } else {
        eligable = !!permissions[type];
    }

    if (!eligable) {
        return false;
    }

    if (capability) {
        if (permissions[type].capabilities && !permissions[type].capabilities.includes(capability)) {
            return false;
        }
    }

    if (id) {
        if (permissions[type].ids && !permissions[type].ids.includes(id)) {
            return false;
        }
    }

    return true;
}
